import React, { FC, useEffect } from 'react';
import { Routes } from 'react-router-dom';
import i18next from 'i18next';
import { useDispatch } from 'react-redux';
import { IaTheme } from 'ia-react-core';
import AxiosSetup from '~/components/AxiosSetup';
import { contentRequested } from './App.actions';
import MainLayout from '../layouts/MainLayout/MainLayout';
import Constants from './Constants';
import GetInternalRoute from './GetInternalRoute';

export interface AppProps {
  theme: IaTheme;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const App: FC<AppProps> = ({ theme }) => {
  useEffect(() => {
    document.body.id = sessionStorage.getItem('dealersExperience');
  }, []);
  const dispatch = useDispatch();
  const lang = i18next.language;

  useEffect(() => {
    dispatch(contentRequested(lang));
  }, [dispatch, lang]);
  return (
    <MainLayout>
      <AxiosSetup />
      <Routes>
        {GetInternalRoute(Constants.Pages.home)}
        {GetInternalRoute(Constants.Pages.changePassword)}
        {GetInternalRoute(Constants.Pages.changePasswordConfirm)}
        {GetInternalRoute(Constants.Pages.loggingTest)}
        {GetInternalRoute(Constants.Pages.accessError)}
        {GetInternalRoute(Constants.Pages.technicalError)}
        {GetInternalRoute(Constants.Pages.technicalErrorWithLogoff)}
        {GetInternalRoute(Constants.Pages.notFound)}
        {GetInternalRoute(Constants.Pages.timeoutError)}
        {GetInternalRoute(Constants.Pages.logOff)}
        {GetInternalRoute(Constants.Pages.catchAll)}
      </Routes>
    </MainLayout>
  );
};

export default App;
